module.exports = __webpack_public_path__ + "img/bank.399130f2.png";